var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal" }, [
    _c(
      "form",
      {
        staticClass: "card w-modal h-modal",
        attrs: { id: "supporter-details" }
      },
      [
        _c("div", { staticClass: "header" }, [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "close",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_c("i", { staticClass: "icn icn-x sm" })]
          )
        ]),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "field" }, [
            _c("h2", [_vm._v("Donation")]),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Date")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: {
                    value: _vm.formatDate(_vm.payload.donation.donationDate)
                  }
                })
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Lastest Transaction Date")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.formatDate(_vm.payload.createdAt) }
                })
              ])
            ]),
            _c("div", { staticClass: "field" }, [
              _c("label", [_vm._v("Amount")]),
              _c("input", {
                attrs: { type: "text", disabled: "" },
                domProps: { value: "A$" + _vm.payload.donation.amount }
              })
            ]),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Payment Type")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.getPaymentType() }
                })
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Donation Type")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.donation.type }
                })
              ])
            ]),
            _vm.payload.transaction.rawResponse &&
            _vm.payload.transaction.rawResponse.CardHolderName
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Card Holder Name")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: {
                        value:
                          _vm.payload.transaction.rawResponse.CardHolderName
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.payload.transaction.rawResponse &&
            _vm.payload.transaction.rawResponse.TruncatedCard
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Masked Credit Card")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: {
                        value: _vm.payload.transaction.rawResponse.TruncatedCard
                      }
                    })
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Expiry Date")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: {
                        value:
                          _vm.payload.transaction.rawResponse.ExpM +
                          "/" +
                          _vm.payload.transaction.rawResponse.ExpY
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.payload.transaction.receiptNumber
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Receipt Number")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.transaction.receiptNumber }
                    })
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _vm.payload.donation.packageCode
                      ? _c("label", [_vm._v("Package Code")])
                      : _vm._e(),
                    _vm.payload.donation.packageCode
                      ? _c("input", {
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: _vm.payload.donation.packageCode }
                        })
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Payment Status")]),
                _c("div", { staticClass: "mt-3" }, [
                  _vm.transactionStatus &&
                  _vm.transactionStatus.toLowerCase() === _vm.completed
                    ? _c("div", { staticClass: "flex" }, [
                        _c("img", {
                          staticClass: "h-5 mr-2",
                          attrs: { src: require("@/assets/img/tick_icon.svg") }
                        }),
                        _c("div", { staticClass: "flex flex-row" }, [
                          _vm._v("Success")
                        ])
                      ])
                    : _vm._e(),
                  _vm.transactionStatus &&
                  _vm.transactionStatus.toLowerCase() === _vm.completed &&
                  !_vm.showResendReceiptInput &&
                  _vm.canEdit
                    ? _c(
                        "button",
                        {
                          staticClass: "secondary mt-2",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.showResendReceiptInput = true
                              _vm.message = null
                            }
                          }
                        },
                        [
                          _vm._v(
                            " Send " +
                              _vm._s(
                                _vm.payload.donation.type === "Single"
                                  ? "Receipt"
                                  : "Confirmation"
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.showResendReceiptInput
                    ? _c("div", { staticClass: "mt-4" }, [
                        _c("form", { attrs: { id: "send-receipt" } }, [
                          _vm.payload.supporter.email
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col py-2 px-4 border-2 border-dotted gap-y-2"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "flex flex-row items-center"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectReceiptEmail,
                                            expression: "selectReceiptEmail"
                                          }
                                        ],
                                        staticClass: "mr-4",
                                        attrs: {
                                          id: "supporterEmail",
                                          type: "radio",
                                          value: "supporterEmail"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.selectReceiptEmail,
                                            "supporterEmail"
                                          )
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              _vm.selectReceiptEmail =
                                                "supporterEmail"
                                            },
                                            function($event) {
                                              return _vm.updateReceiptEmail()
                                            }
                                          ]
                                        }
                                      }),
                                      _vm._v(
                                        " Send to the supporter's email: " +
                                          _vm._s(_vm.payload.supporter.email) +
                                          " "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "flex flex-row items-center"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectReceiptEmail,
                                            expression: "selectReceiptEmail"
                                          }
                                        ],
                                        staticClass: "mr-4",
                                        attrs: {
                                          id: "differentEmail",
                                          type: "radio",
                                          value: "differentEmail"
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.selectReceiptEmail,
                                            "differentEmail"
                                          )
                                        },
                                        on: {
                                          change: [
                                            function($event) {
                                              _vm.selectReceiptEmail =
                                                "differentEmail"
                                            },
                                            function($event) {
                                              return _vm.updateReceiptEmail()
                                            }
                                          ]
                                        }
                                      }),
                                      _vm._v(" Send to a different email ")
                                    ]
                                  ),
                                  _vm.selectReceiptEmail === "differentEmail"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.receiptEmail,
                                            expression: "receiptEmail"
                                          }
                                        ],
                                        attrs: {
                                          type: "text",
                                          required: "",
                                          pattern:
                                            "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
                                          title: "E.g: johndoe@example.com",
                                          placeholder: "Email",
                                          autocomplete: "nope"
                                        },
                                        domProps: { value: _vm.receiptEmail },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.receiptEmail =
                                              $event.target.value
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  !_vm.isSendingReceipt
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "w-40",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.sendReceipt()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Send " +
                                              _vm._s(
                                                _vm.payload.donation.type ===
                                                  "Single"
                                                  ? "Receipt"
                                                  : "Confirmation"
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.isSendingReceipt
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "secondary w-40",
                                          attrs: { type: "button" }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "h-4",
                                            attrs: {
                                              src: require("@/assets/img/spinning.svg")
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e(),
                          !_vm.payload.supporter.email
                            ? _c("div", { staticClass: "flex flex-row" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.receiptEmail,
                                      expression: "receiptEmail"
                                    }
                                  ],
                                  attrs: {
                                    type: "text",
                                    required: "",
                                    pattern:
                                      "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
                                    title: "E.g: johndoe@example.com",
                                    placeholder: "Email",
                                    autocomplete: "nope"
                                  },
                                  domProps: { value: _vm.receiptEmail },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.receiptEmail = $event.target.value
                                    }
                                  }
                                }),
                                !_vm.isSendingReceipt
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "w-40 ml-4",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.sendReceipt()
                                          }
                                        }
                                      },
                                      [_vm._v(" Send Receipt ")]
                                    )
                                  : _vm._e(),
                                _vm.isSendingReceipt
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "secondary w-40 ml-4",
                                        attrs: { type: "button" }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "h-4",
                                          attrs: {
                                            src: require("@/assets/img/spinning.svg")
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm.message
                    ? _c(
                        "div",
                        { staticClass: "field mt-2" },
                        [_c("alert", { attrs: { message: _vm.message } })],
                        1
                      )
                    : _vm._e(),
                  _vm.transactionStatus === _vm.failed
                    ? _c("div", { staticClass: "flex" }, [
                        _c("img", {
                          staticClass: "h-5 mr-2",
                          attrs: { src: require("@/assets/img/cross_icon.svg") }
                        }),
                        _vm._v(" Failed ")
                      ])
                    : _vm._e(),
                  _vm.transactionStatus === _vm.pending &&
                  (_vm.payload.paymentCaptureSystem === "web" ||
                    _vm.payload.transaction.paymentType === "direct-debit")
                    ? _c("div", { staticClass: "flex" }, [
                        _c("img", {
                          staticClass: "h-5 mr-2",
                          attrs: {
                            src: require("@/assets/img/process_icon.svg")
                          }
                        }),
                        _vm._v(" Processing by bank ")
                      ])
                    : _vm._e(),
                  _vm.transactionStatus === _vm.pending &&
                  _vm.payload.paymentCaptureSystem === "sms"
                    ? _c("div", { staticClass: "flex" }, [
                        _c("img", {
                          staticClass: "h-5 mr-2",
                          attrs: { src: require("@/assets/img/spinning.svg") }
                        }),
                        _vm._v(" Waiting for payment ")
                      ])
                    : _vm._e(),
                  _vm.transactionStatus === _vm.pending &&
                  _vm.payload.paymentCaptureSystem === "sms"
                    ? _c("div", [
                        !_vm.isResending && !_vm.isResent
                          ? _c(
                              "button",
                              {
                                staticClass: "primary mt-2",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.resendToken()
                                  }
                                }
                              },
                              [_vm._v(" Resend SMS ")]
                            )
                          : _vm._e(),
                        _vm.isResent
                          ? _c("h3", [
                              _vm._v("A payment message has been sent")
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ])
              ])
            ]),
            _c("div", { staticClass: "row mt-2" }, [
              _vm.payload.agentEmail
                ? _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Agent Email")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.agentEmail }
                    })
                  ])
                : _vm._e(),
              _c("div", { staticClass: "field" }, [
                _vm.payload.donation.webId
                  ? _c("label", [_vm._v("Reference Number")])
                  : _vm._e(),
                _vm.payload.donation.webId
                  ? _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.donation.webId }
                    })
                  : _vm._e()
              ])
            ])
          ]),
          _c("div", { staticClass: "field mt-6" }, [
            _c("h2", [_vm._v("Supporter")]),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "w-1/4" }, [
                _c("label", [_vm._v("Title")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.supporter.title }
                })
              ])
            ]),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("First Name")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.supporter.firstName }
                })
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Last Name")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.supporter.lastName }
                })
              ])
            ]),
            _vm.payload.supporter.phoneNumber
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Phone Number")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.supporter.phoneNumber }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.payload.supporter.email
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Email")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.supporter.email }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.payload.supporter.businessName
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Business Name")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.supporter.businessName }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.payload.addressFullLine
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Address")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.addressFullLine }
                    })
                  ])
                ])
              : _vm._e()
          ]),
          _vm.payload.donation.isGift
            ? _c("div", { staticClass: "field mt-6" }, [
                _c("h2", [_vm._v("Gift Recipient")]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "w-1/4" }, [
                    _c("label", [_vm._v("Title")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.donation.gift.title }
                    })
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("First Name")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.donation.gift.firstName }
                    })
                  ]),
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Last Name")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.payload.donation.gift.lastName }
                    })
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Address")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: { value: _vm.giftAddress }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          _c("div", { staticClass: "field mt-6" }, [
            _c("h2", [_vm._v("Product")]),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("ID")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.donationProductDetails.id }
                })
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Name")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: {
                    value: _vm.payload.donationProductDetails.productname
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "row mt-2" }, [
              _vm.payload.donationProductDetails.producttype
                ? _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v("Type")]),
                    _c("input", {
                      attrs: { type: "text", disabled: "" },
                      domProps: {
                        value: _vm.payload.donationProductDetails.producttype
                      }
                    })
                  ])
                : _vm._e(),
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Appeal ID")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.donation.appealId }
                })
              ])
            ]),
            _c("div", { staticClass: "row mt-2" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Fund ID")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.donation.fundId }
                })
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Campaign ID")]),
                _c("input", {
                  attrs: { type: "text", disabled: "" },
                  domProps: { value: _vm.payload.donation.campaignId }
                })
              ])
            ])
          ])
        ]),
        _vm.showButton
          ? _c("div", { staticClass: "footer" }, [
              _c("div", { staticClass: "flex-grow" }),
              _c(
                "button",
                {
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.makeAnotherDonation()
                    }
                  }
                },
                [_vm._v("Make another donation")]
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "flex flex-col" }, [
        _c("h1", { staticClass: "ml-2" }, [_vm._v("Details")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }